export default __webpack_public_path__ + "static/media/wallet.953151c2.svg";